/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Resident } from './Resident';
import {
    ResidentFromJSON,
    ResidentFromJSONTyped,
    ResidentToJSON,
} from './Resident';

/**
 * 
 * @export
 * @interface ResidentsFindAllResponse
 */
export interface ResidentsFindAllResponse {
    /**
     * 
     * @type {Array<Resident>}
     * @memberof ResidentsFindAllResponse
     */
    data: Array<Resident>;
    /**
     * 
     * @type {number}
     * @memberof ResidentsFindAllResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ResidentsFindAllResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ResidentsFindAllResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResidentsFindAllResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the ResidentsFindAllResponse interface.
 */
export function instanceOfResidentsFindAllResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function ResidentsFindAllResponseFromJSON(json: any): ResidentsFindAllResponse {
    return ResidentsFindAllResponseFromJSONTyped(json, false);
}

export function ResidentsFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResidentsFindAllResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ResidentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function ResidentsFindAllResponseToJSON(value?: ResidentsFindAllResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ResidentToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

